import classnames from "classnames"
import React from "react"
import Markdown, {MarkdownProps} from "@irati/ui/src/Markdown"
import styled, {css} from "styled-components"

interface Props extends Pick<MarkdownProps, "componentProps" | "values"> {
  id: string
  values?: Record<string, any>
  white?: boolean
  bullets?: boolean
}

const Span = styled.div<Pick<Props, "bullets">>`
  ${({theme, bullets}) =>
    bullets &&
    css`
      & ul {
        padding-inline-start: ${theme.spacing.two};
      }

      & li {
        padding-left: ${theme.spacing.one};
      }

      & li::marker {
        color: ${theme.colors.utility.promo};
        content: "▶";
      }
    `}
`

export default function IntlMarkdown({id, values, bullets, white, componentProps}: Props) {
  return (
    <Span bullets={bullets}>
      <Markdown
        source={id}
        values={values}
        componentProps={componentProps}
        className={classnames({
          "reward-wallet__white--markdown": white
        })}
      />
    </Span>
  )
}
